import { z } from "zod";

import { AD_PACKAGE_KEYS } from "./AdPackageKey";
import { AD_UPGRADE_KEYS } from "./AdUpgradeKey";

export const AD_PRODUCT_KEYS = [
  ...AD_PACKAGE_KEYS,
  ...AD_UPGRADE_KEYS,
] as const;

export const AD_PRODUCT_KEY_SCHEMA = z.enum(AD_PRODUCT_KEYS, "Invalid product key");

export type AdProductKey = z.infer<typeof AD_PRODUCT_KEY_SCHEMA>;